import General from './General'
import Location from './Location'
import License from './License'
import VerificationStatus from './VerificationStatus'
import VerificationModal from './VerificationModal'

export {
  General,
  Location,
  License,
  VerificationStatus,
  VerificationModal
}
